import React from 'react';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { useNavigate } from '@thd-olt-component-react/router';
import { clickEvents } from '../../utils/analytics';
import { EXP_ROUTES } from '../../utils/constants';
import { JobPostingIntro } from '../common/JobPostingIntro/JobPostingIntro';

const FindTalentSection = ({ authorized }) => {

  const navigate = useNavigate();

  return (
    <div className="slm-find-candidate-block__root">
      <Row>
        <Col md={12} sm={12} xs={12}>
          <h2 className="slm-find-candidate-block__header">Post Jobs, Find Talent</h2>
        </Col>
      </Row>
      <Row>
        <Col xs={8} md={5} fallback={12} className="slm-find-candidate-block__content-col-text">
          Did you know you can easily post job openings to our network of candidates seeking
          work? Click "Post Jobs" to post your first job today.
        </Col>
        {authorized && (
          <Col xs={4} md={7} fallback={12}>
            <Button
              data-testid="get-started-btn"
              className="p2p-landing-button p2p-landing-button__get-started"
              onClick={() => {
                clickEvents.landingPageLinkClick('get started');
                navigate(EXP_ROUTES.JOB_POSTINGS);
              }}
            >
              Post Jobs
            </Button>
          </Col>
        )}
      </Row>
      <JobPostingIntro />
    </div>
  );
};

export default FindTalentSection;
